export default [
  {
    text: 'First name',
    value: 'firstname',
    apiSort: 'users.firstname',
  },
  {
    text: 'Last name',
    value: 'lastname',
    apiSort: 'users.lastname',
  },
  {
    text: 'Employee',
    value: 'employee',
    apiSort: 'users.employee',
  },
  {
    text: 'Email',
    value: 'email',
    apiSort: 'users.email',
  },
  {
    text: 'Role',
    value: 'role.name',
    apiSort: 'roles.name',
  },
  {
    text: 'Created',
    value: 'created_at',
  },
  {
    text: 'Status',
    value: 'status.name',
    apiSort: 'users.status',
  },
];
